export interface UserUploadConfig {
  maxFileSize: number;
  maxFiles: number;
}

export const [ASSISTANT, TOOL, ERROR, INTENT] = [
  "assistant",
  "tool",
  "error",
  "intent",
];
